<form [formGroup]="form" class="one-column">
  <mat-form-field appearance="fill">
    <mat-label>Lățimea (B)</mat-label>
    <input matInput type="text" autocomplete="off" pattern="^[0-9]+[,.]?[0-9]*$" (change)="formDecimalInputChange($event, 'width')"
           formControlName="width"
           required>
    <span matSuffix>metri</span>
  </mat-form-field>
  <div class="form-warning" *ngIf="this.form?.controls?.width?.value > 100">
    {{getNotInMetersWarningText('width')}}
    <button (click)="updateToMeters('width')">Schimbă</button>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>Înălțimea (C)</mat-label>
    <input matInput type="text" autocomplete="off" pattern="^[0-9]+[,.]?[0-9]*$" (change)="formDecimalInputChange($event, 'height')"
           formControlName="height" required>
    <span matSuffix>metri</span>
  </mat-form-field>
  <div class="form-warning" *ngIf="this.form?.controls?.height?.value > 100">
    {{getNotInMetersWarningText('height')}}
    <button (click)="updateToMeters('height')">Schimbă</button>
  </div>
  <mat-form-field *ngIf="roofType === roofTypes.TwoSlopes" appearance="fill">
    <mat-label>Înălțimea (D)</mat-label>
    <input matInput type="text" autocomplete="off" pattern="^[0-9]+[,.]?[0-9]*$" (change)="formDecimalInputChange($event, 'height2')"
           formControlName="height2" required>
    <span matSuffix>metri</span>
  </mat-form-field>
  <div class="form-warning" *ngIf="this.form?.controls?.height2?.value > 100">
    {{getNotInMetersWarningText('height2')}}
    <button (click)="updateToMeters('height2')">Schimbă</button>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>Număr hornuri</mat-label>
    <input matInput type="number" autocomplete="off" min="0" max="10" pattern="^\d*$" formControlName="chimneys">
    <span matSuffix>nr.</span>
  </mat-form-field>
  <mat-checkbox formControlName="splitHeightInTwoRows" color="primary">
    <span class="prevent-select">Împarte înălțimea tablei pe două rânduri</span>
  </mat-checkbox>
  <em class="additional-info" style="margin-top: -5px; margin-bottom: 5px;">Înălțimea maximă la care livrăm tabla este de 5 metri, însă poate fi dificil de lucrat cu ea. Această opțiune va permite să împărțiți bucățile de tablă în 2 rânduri</em>
</form>

